import React from 'react';
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import StorageService from '../services/StorageService';
import axios from 'axios';
import { MdDone, MdClear, MdCreate } from 'react-icons/md';

class DataFieldForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      fieldName: '',
      searchable: false,
      searchKeyPattern: '',
    };
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  checkboxChangeHandler = event => {
    this.setState({
      [event.target.name]: !this.state[event.target.name],
    });
  };

  handleSubmit = event => {
    event.preventDefault();
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;
    const org = StorageService.getSession('selected_org');

    const data = {
      session_key: user.session_key,
      CompanyID: org.CompanyID,
      PersonType: this.props.data.filterKey,
      FieldName: this.state.fieldName,
      FieldType: 'String',
      Searchable: this.state.searchable ? 1 : 0,
      SearchKeyPattern: this.state.searchKeyPattern,
    };

    if (!this.props.data.isEdit) {
      axios
        .post(url + ':3000/v1/person/createDataField', data)
        .then(response => {
          const result = response.data;
          if (result.error == true) {
            this.props.closeModal(<MdClear />, result.message, 'error', false);
            return;
          }

          this.props.closeModal(
            <MdDone />,
            'New data field added successfully.',
            'success',
            false,
          );
        })
        .catch(error => {
          alert(error);
        });
    } else {
      data.FieldID = this.props.data.fieldId;
      axios
        .post(url + ':3000/v1/person/updateDataField', data)
        .then(response => {
          const result = response.data;
          if (result.error == true) {
            this.props.closeModal(<MdClear />, result.message, 'error', false);
            return;
          }
          this.props.closeModal(
            <MdDone />,
            'Data field updated successfully.',
            'success',
            false,
          );
        })
        .catch(error => {
          alert(error);
        });
    }
  };

  componentDidMount() {
    if (this.props.data.isEdit) {
      let id = this.props.data.fieldId;
      const dt = this.props.data.dataFieldList.find(e => e.FieldID === id);
      this.setState({
        fieldName: dt.FieldName,
        searchKeyPattern: dt.SearchKeyPattern,
        searchable: dt.Searchable === 1 ? true : false,
      });
    }
  }

  render() {
    return (
      <Form onSubmit={this.handleSubmit} className="AuthForm">
        <ModalHeader toggle={this.props.onToggleModal()}>
          Data Field Information
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <FormGroup>
                <Label for="fieldName">Field Name</Label>
                <Input
                  type="text"
                  name="fieldName"
                  value={this.state.fieldName}
                  onChange={this.changeHandler}
                  required
                />
              </FormGroup>
              <FormGroup>
                <Label for="searchKeyPattern">Search Key Pattern</Label>
                <Input
                  type="text"
                  name="searchKeyPattern"
                  value={this.state.searchKeyPattern}
                  onChange={this.changeHandler}
                />
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input
                    type="checkbox"
                    name="searchable"
                    checked={this.state.searchable}
                    onChange={this.checkboxChangeHandler}
                  />{' '}
                  Searchable
                </Label>
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            className="theme-button theme-button-secondary"
            onClick={this.props.onToggleModal()}
          >
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            {this.props.data.isEdit ? 'Save' : 'Add Data Field'}
          </Button>{' '}
        </ModalFooter>
      </Form>
    );
  }
}

export default DataFieldForm;
